import View from '@play-co/timestep-core/lib/ui/View';
import { Feature } from 'src/replicant/analytics';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import PopupRewardsChest from './PopupRewardsChest';
import { resubscriptionGemsReward } from 'src/replicant/chatbot/chatbot.ruleset';

/** Optional reward amount for legacy and A/B 0489 resubscribe confirmations. */
type OpenArgs = { amount?: number };

/** Reward chest confirmation shared by legacy and incentivized OA claims. */
export default class PopupResubscribeReward extends PopupRewardsChest {
  /**
   * Create the resubscribe reward confirmation.
   *
   * @param opts Popup parent and close callback.
   */
  public constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      tracking: {
        feature: Feature.RESUBSCRIBE._,
        $subFeature: Feature.RESUBSCRIBE.REWARD,
      },
    });
  }

  /**
   * Display the resubscribe reward chest with the requested gem amount.
   *
   * @param args Optional amount; defaults to the legacy 50-gem reward.
   */
  public init(args: OpenArgs): void {
    const rewards: Match2Reward[] = [
      {
        type: 'gems',
        amount: args.amount ?? resubscriptionGemsReward,
      },
    ];

    super.init({ rewards });
  }
}
